import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SearchParam } from '@constants/common';
import { logError } from '@utils/errors';

/**
 * Removes params from the URL in place, with no history entry — a link that
 * has done its job. One call removes them all, so they go in one replace.
 */
export const useDeleteSearchParams = () => {
  const [, setSearchParams] = useSearchParams();

  return useCallback(
    (paramNames: SearchParam[]) => {
      // `setSearchParams` ends up in `history.replaceState`, which react-router
      // calls without a guard and whose promise it drops on the floor — a throw
      // there would only ever show up as an unowned rejection.
      try {
        setSearchParams(
          (searchParams) => {
            const nextSearchParams = new URLSearchParams(searchParams);

            paramNames.forEach((name) => nextSearchParams.delete(name));

            return nextSearchParams;
          },
          { replace: true }
        );
      } catch (error) {
        logError(error, { location: 'useDeleteSearchParams' });
      }
    },
    [setSearchParams]
  );
};
